__turbopack_context__.v({
  "citationHighlighted": "scy_ra_citationHighlighted",
  "paragraphwrapper": "scy_ra_paragraphwrapper",
});
